import { LIMPAR_USUARIOS } from '../types'

export default function limparUsuarios() {
  return {
    type: LIMPAR_USUARIOS,
  }
}
